import React from 'react'



const SeatLayoutVerticalSkeleton = () => {
  return (
     <div className='seatLayoutVerticalSkeletonContainer'>
         <div className='deck1-skeleton'>
            <div className='first-row'>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
            </div>

            <div className='first-row'>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
            </div>

            <div className='gap-row'>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
            </div>

            <div className='first-row'>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
            </div>
         </div>
         <div style={{marginLeft:"40px"}}></div>
          <div className='deck1-skeleton'>
            <div className='first-row'>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
                <div className='seat-skeleton'> &nbsp; </div>
            </div>

            <div className='first-row'>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
            </div>

            <div className='gap-row'>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
                <div className='seat-gap-skeleton'> </div>
            </div>

            <div className='first-row'>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
                <div className='seat-skeleton'> </div>
            </div>
         </div>
         
     </div>
  )
}

export default SeatLayoutVerticalSkeleton